import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "text-22 font-medium text-black-900" }
const _hoisted_3 = {
  ref: "closeBtn",
  type: "button",
  class: "modal-popup__close"
}
const _hoisted_4 = { class: "overflow-hidden" }
const _hoisted_5 = {
  key: 0,
  class: "mt-14 flex w-full flex-col gap-y-18 font-medium"
}
const _hoisted_6 = ["checked", "onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "sticky bottom-0 left-0 mt-auto w-full" }
const _hoisted_10 = { class: "flex justify-between gap-x-16 bg-white p-16" }
const _hoisted_11 = {
  key: 0,
  class: "hide-scrollbar mt-12 flex items-center gap-x-8 overflow-x-scroll tablet:gap-x-16"
}
const _hoisted_12 = ["v-if"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "cursor-default text-12 font-medium text-black-900" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_collection_filter_accordion = _resolveComponent("collection-filter-accordion")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($data.locale.filter), 1),
      _createElementVNode("button", _hoisted_3, [
        _createVNode(_component_v_icon, {
          icon: "close",
          width: 11,
          height: 11
        })
      ], 512)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter) => {
      return (_openBlock(), _createBlock(_component_collection_filter_accordion, {
        key: filter.label,
        title: filter.label
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (
          filter.label.toLowerCase().includes($data.locale.filter_product_type) ||
          filter.label.toLowerCase().includes($data.locale.filter_collection) ||
          filter.label.toLowerCase().includes($data.locale.filter_sale)
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.values, (value) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: value.value,
                      class: "flex-between"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(value.value) + " (" + _toDisplayString(value.count) + ")", 1),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "filter-checkbox form-checkbox absolute -z-10 opacity-0",
                          checked: $data.activeFilters.includes(value.value),
                          onClick: $event => ($options.toggleFilter(value.value, `${value.param_name}=${value.value}`))
                        }, null, 8, _hoisted_6),
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "cursor-pointer" }, null, -1))
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["mt-14 grid w-full gap-x-16 gap-y-8 font-medium", 
            filter.label.toLowerCase().includes($data.locale.filter_nail_artists)
              ? 'grid-cols-1'
              : 'grid-cols-2'
          ])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.values, (value) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: value.value,
                      type: "button",
                      class: _normalizeClass(["flex w-full cursor-pointer items-center gap-x-4 rounded border border-black-200 bg-black-50 p-8 font-medium hover:border-black-300 hover:bg-black-100", [
              $data.activeFilters.includes(value.value) &&
                'border-black-900 !bg-black-100 hover:border-black-900',
              (value.param_name.includes('effects') || value.param_name.includes('colors')) &&
                'capitalize',
            ]]),
                      onClick: $event => ($options.toggleFilter(value.value, `${value.param_name}=${value.value}`))
                    }, [
                      _createElementVNode("img", {
                        src: 
                $data.imageFilterColor
                  .replace(
                    'black_small.jpg',
                    `${value.label
                      .toLowerCase()
                      .trim()
                      .normalize('NFD')
                      .replace(/^-+|-+$/g, '')
                      .replace(/[\u0300-\u036f]/g, '')
                      .replace('@', '')
                      .replace('/', '-')
                      .replace(/ /g, '-')}_50x.png`
                  )
                  .split('?')[0]
              ,
                        class: "h-18 w-18"
                      }, null, 8, _hoisted_8),
                      _createElementVNode("span", null, _toDisplayString(value.value), 1)
                    ], 10, _hoisted_7))
                  }), 128))
                ], 2))
          ])
        ]),
        _: 2
      }, 1032, ["title"]))
    }), 128)),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-xsmall btn-secondary border border-black-900", $data.clearBtnSkeletonClass]),
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.clearAllFilters && $options.clearAllFilters(...args)))
        }, _toDisplayString($data.locale.filter_clear), 3),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-xsmall btn-primary flex-1", $data.applyBtnSkeletonClass]),
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.applyFilters && $options.applyFilters(...args)))
        }, _toDisplayString($data.locale.filter_apply), 3)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#filters_tag" }, [
      ($data.filterTags.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filterTags, (filter, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: filter,
                class: _normalizeClass(["flex items-center gap-x-8 rounded border border-black-200 bg-black-100 px-8 py-2 capitalize", i === $data.activeFilter && $data.skeletonClass]),
                "v-if": filter
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: $event => ($options.removeFilter(filter, i))
                }, [
                  _createVNode(_component_v_icon, {
                    color: "#121212",
                    icon: "close",
                    width: 8,
                    height: 8
                  })
                ], 8, _hoisted_13),
                _createElementVNode("span", _hoisted_14, _toDisplayString(filter), 1)
              ], 10, _hoisted_12))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}